import { Injectable } from '@angular/core';

import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { SyncUserSettingsService } from '@frontend/sports/user/feature';

import {
    EarlyPayoutEditBetService,
    EarlyPayoutMyBetsService,
    EarlyPayoutSubmitEditBetService,
    EarlyPayoutSubmitMyBetsService,
    EarlyPayoutSubscriptionEditBetService,
    EarlyPayoutSubscriptionMyBetsService,
} from './early-payout-injection-tokens';
import { EarlyPayoutSubmitService } from './early-payout-submit.service';
import { EarlyPayoutSubscriptionMapperService } from './early-payout-subscription-mapper.service';
import { EarlyPayoutSubscriptionService } from './early-payout-subscription.service';
import { EarlyPayoutUtils } from './early-payout-utils';
import { EarlyPayoutService } from './early-payout.service';
import { EPSDetailedLogger } from './eps-detailed-logger.service';
import { EarlyPayoutHelpers } from './my-bets-earlypayout-helpers';
import { MyBetsEarlyPayoutService } from './my-bets-earlypayout.service';

class MyBetsEarlyPayoutServiceFactory {
    constructor(
        private epHelpers: EarlyPayoutHelpers,
        private loggerFactory: LoggerFactory,
        private earlyPayoutService: EarlyPayoutService,
        private earlyPayoutSubscriptionService: EarlyPayoutSubscriptionService,
        private earlyPayoutSubmitService: EarlyPayoutSubmitService,
        private epsLogger: EPSDetailedLogger,
        private earlyPayoutSubscriptionMapperService: EarlyPayoutSubscriptionMapperService,
        private earlyPayoutUtils: EarlyPayoutUtils,
        private userSettings: SyncUserSettingsService,
    ) {}

    create(): MyBetsEarlyPayoutService {
        return new MyBetsEarlyPayoutService(
            this.earlyPayoutService,
            this.earlyPayoutSubscriptionService,
            this.epHelpers,
            this.loggerFactory,
            this.earlyPayoutSubmitService,
            this.epsLogger,
            this.earlyPayoutSubscriptionMapperService,
            this.userSettings,
            this.earlyPayoutUtils,
        );
    }
}

@Injectable({ providedIn: 'root' })
export class MyBetsEarlyPayoutServiceMyBetsFactory extends MyBetsEarlyPayoutServiceFactory {
    constructor(
        epHelpers: EarlyPayoutHelpers,
        loggerFactory: LoggerFactory,
        earlyPayoutService: EarlyPayoutMyBetsService,
        earlyPayoutSubscriptionService: EarlyPayoutSubscriptionMyBetsService,
        earlyPayoutSubmitService: EarlyPayoutSubmitMyBetsService,
        epsLogger: EPSDetailedLogger,
        earlyPayoutSubscriptionMapperService: EarlyPayoutSubscriptionMapperService,
        earlyPayoutUtils: EarlyPayoutUtils,
        userSettings: SyncUserSettingsService,
    ) {
        super(
            epHelpers,
            loggerFactory,
            earlyPayoutService,
            earlyPayoutSubscriptionService,
            earlyPayoutSubmitService,
            epsLogger,
            earlyPayoutSubscriptionMapperService,
            earlyPayoutUtils,
            userSettings,
        );
    }
}

@Injectable({ providedIn: 'root' })
export class MyBetsEarlyPayoutServiceEditBetFactory extends MyBetsEarlyPayoutServiceFactory {
    constructor(
        epHelpers: EarlyPayoutHelpers,
        loggerFactory: LoggerFactory,
        earlyPayoutService: EarlyPayoutEditBetService,
        earlyPayoutSubscriptionService: EarlyPayoutSubscriptionEditBetService,
        earlyPayoutSubmitService: EarlyPayoutSubmitEditBetService,
        epsLogger: EPSDetailedLogger,
        earlyPayoutSubscriptionMapperService: EarlyPayoutSubscriptionMapperService,
        earlyPayoutUtils: EarlyPayoutUtils,
        userSettings: SyncUserSettingsService,
    ) {
        super(
            epHelpers,
            loggerFactory,
            earlyPayoutService,
            earlyPayoutSubscriptionService,
            earlyPayoutSubmitService,
            epsLogger,
            earlyPayoutSubscriptionMapperService,
            earlyPayoutUtils,
            userSettings,
        );
    }
}
